// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Belt_Id = require("rescript/lib/js/belt_Id.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");

function MakeCustomMapWithDeccoSupport(ComparableArg) {
  var KeyCompare = Belt_Id.MakeComparable({
        cmp: ComparableArg.cmp
      });
  var make = function (param) {
    return Belt_Map.make(KeyCompare);
  };
  var fromArray = function (param) {
    return Belt_Map.fromArray(param, KeyCompare);
  };
  var kvPairs_encode = function (encoder_value, v) {
    return Decco.arrayToJson((function (param) {
                  return [
                          Curry._1(ComparableArg.t_encode, param[0]),
                          Curry._1(encoder_value, param[1])
                        ];
                }), v);
  };
  var kvPairs_decode = function (decoder_value, v) {
    return Decco.arrayFromJson((function (json) {
                  var match = Js_json.classify(json);
                  if (typeof match === "number") {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  if (match.TAG !== /* JSONArray */3) {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  var match$1 = match._0;
                  if (match$1.length !== 2) {
                    return Decco.error(undefined, "Incorrect cardinality", json);
                  }
                  var v0 = match$1[0];
                  var v1 = match$1[1];
                  var match$2 = Curry._1(ComparableArg.t_decode, v0);
                  var match$3 = Curry._1(decoder_value, v1);
                  if (match$2.TAG === /* Ok */0) {
                    if (match$3.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: [
                                match$2._0,
                                match$3._0
                              ]
                            };
                    }
                    var e = match$3._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: "[1]" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = match$2._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }), v);
  };
  var t_encode = function (value_encode, m) {
    return kvPairs_encode(value_encode, Belt_Map.toArray(m));
  };
  var t_decode = function (value_decode, encoded) {
    var decodeError = kvPairs_decode(value_decode, encoded);
    if (decodeError.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: Belt_Map.fromArray(decodeError._0, KeyCompare)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: decodeError._0
            };
    }
  };
  return {
          KeyCompare: KeyCompare,
          make: make,
          fromArray: fromArray,
          kvPairs_encode: kvPairs_encode,
          kvPairs_decode: kvPairs_decode,
          t_encode: t_encode,
          t_decode: t_decode
        };
}

exports.MakeCustomMapWithDeccoSupport = MakeCustomMapWithDeccoSupport;
/* No side effect */
